import React from "react";
import "./OutOfCreditsModal.scss";
import { PlanOptions, ModalDescriptions } from "./constants";
import FlowerBg from "./assets/flower-bg.png";
import CloseIcon from "./assets/close.svg";
import starIcon from "./assets/star.svg";
import CheckIcon from "./assets/check.svg";

const OutOfCreditsModal = ({
  show,
  onClose,
  onSubscribe,
  variant = "outOfCredits", // 'notEnoughCredits', 'outOfCredits', 'lessThanRequiredCredits'
  reverseTitleColor = false,
}) => {
  if (!show) {
    return null;
  }

  const currentTitle =
    ModalDescriptions[variant]?.title ||
    ModalDescriptions.notEnoughCredits.title;
  const currentDescription =
    ModalDescriptions[variant]?.description ||
    ModalDescriptions.notEnoughCredits.description;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div
      className="overlay out-of-credits-modal-wrapper"
      onClick={handleOverlayClick}
    >
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="close-btn" onClick={onClose}>
          <img src={CloseIcon} alt="close" />
        </button>

        {/* Flower Background */}
        <div className="flower-bg">
          <img src={FlowerBg} alt="flower decoration" />
        </div>

        {/* Title */}
        <div className="modal-title">
          {reverseTitleColor ? (
            <>
              <span className="pink-text">{currentTitle.pink}</span>&nbsp;
              <span className="black-text">{currentTitle.black}</span>
            </>
          ) : (
            <>
              <span className="black-text">{currentTitle.black}</span>&nbsp;
              <span className="pink-text">{currentTitle.pink}</span>
            </>
          )}
        </div>

        {/* Description */}
        <div className="modal-description">{currentDescription}</div>

        {/* Plans */}
        <div className="plans-container">
          {PlanOptions.map((plan, index) => (
            <div
              key={index}
              className={`plan-card ${plan.isMostPopular ? "popular" : ""}`}
            >
              {plan.isMostPopular && (
                <div className="most-popular-badge">
                  <img src={starIcon} alt="start" />
                  <div>Most Popular</div>
                </div>
              )}
              <h3 className="plan-title">
                {plan.title}
                {plan.icon && <img src={plan.icon} alt="icon" />}
              </h3>
              <ul className="plan-features">
                {plan.descriptions.map((desc, i) => {
                  const hasDescription = Array.isArray(desc);
                  const title = hasDescription ? desc[0] : desc;
                  const description = hasDescription ? desc[1] : null;

                  return (
                    <li key={i}>
                      <img src={CheckIcon} alt="check" />
                      {hasDescription ? (
                        <div className="feature-text">
                          <span>{title}</span>
                          <span className="feature-desc">{description}</span>
                        </div>
                      ) : (
                        <span>{title}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        {/* Subscribe Button */}
        <button className="subscribe-btn" onClick={onSubscribe}>
          <span className="subscribe-text">Subscribe Now</span>
          <span className="price-text">From only $4.99/month</span>
        </button>
      </div>
    </div>
  );
};

export default OutOfCreditsModal;
